import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

export default function BlogIsSafe() {
  return (
    <>
      <Navbar />
      <main>
        <article className="pt-[72px]">
          <header className="relative w-full min-h-[360px] md:min-h-[440px] flex items-center overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20safety%20trust%20concept%20with%20warm%20cream%20desk%2C%20a%20small%20shield%20symbol%20next%20to%20organized%20papers%20and%20a%20tablet%2C%20soft%20natural%20morning%20light%2C%20editorial%20still%20life%20photography%2C%20neutral%20beige%20and%20sand%20tones%2C%20sophisticated%20calming%20composition%20conveying%20security%20and%20reliability&width=1800&height=700&seq=blog-header-safe-v3-2026&orientation=landscape"
                alt="Is itaobuyspreadsheet safe honest 2026 review"
                title="Is Itaobuyspreadsheet Safe? Honest Review 2026"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
            </div>
            <div className="relative z-10 w-full px-4 md:px-6">
              <div className="max-w-[900px] mx-auto text-center">
                <span className="inline-block px-4 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 backdrop-blur-sm text-xs font-label text-background-50/90 tracking-wider uppercase whitespace-nowrap mb-5">
                  Safety Review &bull; 2026 Edition
                </span>
                <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-[1.1]">
                  Is Itaobuyspreadsheet Safe?<br />
                  An Honest 2026 Review
                </h1>
                <p className="mt-4 text-sm md:text-base text-background-50/75 font-label max-w-[620px] mx-auto">
                  Addressing the most common safety and privacy concerns about the itaobuy sheet platform with transparent, verified information.
                </p>
              </div>
            </div>
          </header>

          <div className="bg-background-50 py-12 md:py-20">
            <div className="max-w-[780px] mx-auto px-4 md:px-6">
              <section className="mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5 leading-snug">The Short Answer: Yes, and Here Is Why</h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed font-label mb-4">
                  The <strong>itaobuyspreadsheet</strong> platform has been designed with a clear architectural principle: separate research from transactions. This means the platform itself never handles payments, never stores credit card information, and never collects personal shopping data. Its sole function is to organize, display, and link product information in a structured format.
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed font-label mb-4">
                  Every external link on the itaobuyspreadsheet platform uses HTTPS protocols and points directly to verified product pages on the main platform at kaspreadsheet.com. There are no intermediary redirects, no affiliate tracking scripts that compromise privacy, and no hidden data collection mechanisms. This transparency is a core part of why the itaobuy sheet community has grown steadily since launch.
                </p>
              </section>

              <section className="mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5 leading-snug">Privacy: No Account, No Problem</h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed font-label mb-4">
                  One of the strongest privacy features of itaobuyspreadsheet is that it does not require user accounts. You can browse all 14 categories freely without creating a profile, providing an email address, or submitting any personal identifiers. This means there is no persistent browsing history tied to your identity, and no personalized data profiles being built behind the scenes.
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed font-label">
                  The platform uses only essential session cookies for basic functionality — no tracking cookies, no advertising pixels, and no third-party analytics that compromise user privacy. <Link to="/" className="text-primary-600 hover:text-primary-700 underline font-medium cursor-pointer">Return to the itaobuyspreadsheet homepage</Link> to experience this privacy-first approach yourself.
                </p>
              </section>

              <div className="mt-12 pt-8 border-t border-background-200/60">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                  <Link to="/" className="inline-flex items-center space-x-2 px-6 py-3 bg-primary-500 text-background-50 font-label font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    <i className="ri-arrow-left-line"></i>
                    <span>Back to itaobuyspreadsheet Home</span>
                  </Link>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center space-x-2 px-6 py-3 border-2 border-primary-500 text-primary-600 font-label font-medium text-sm rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer">
                    <span>Visit Main Platform</span>
                    <i className="ri-external-link-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </article>
      </main>
      <script type="application/ld+json">
        {`
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": "Is Itaobuyspreadsheet Safe? An Honest 2026 Review",
          "description": "Addressing the most common safety and privacy concerns about the itaobuy sheet platform with transparent, verified information.",
          "image": "https://readdy.ai/api/search-image?query=Elegant%20safety%20trust%20concept%20with%20warm%20cream%20desk%2C%20a%20small%20shield%20symbol%20next%20to%20organized%20papers%20and%20a%20tablet%2C%20soft%20natural%20morning%20light%2C%20editorial%20still%20life%20photography%2C%20neutral%20beige%20and%20sand%20tones%2C%20sophisticated%20calming%20composition%20conveying%20security%20and%20reliability&width=1800&height=700&seq=blog-header-safe-v3-2026&orientation=landscape",
          "datePublished": "2026-06-12",
          "dateModified": "2026-06-27",
          "author": {
            "@type": "Organization",
            "name": "itaobuy.casa"
          },
          "publisher": {
            "@type": "Organization",
            "name": "itaobuy.casa",
            "logo": {
              "@type": "ImageObject",
              "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg"
            }
          },
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "https://itaobuy.casa/blog/is-itaobuyspreadsheet-safe"
          }
        `}
      </script>
      <Footer />
    </>
  );
}